export default __webpack_public_path__ + "static/media/noPlans.acc5a46f.svg";